<template>
  <div class="screen">
    <el-collapse v-model="activeNames" id="sidebar">
      <el-collapse-item :title="$t('sale')" name="3" v-if="isWhale">
        <el-radio-group v-model="params.sale" @change="radioChange">
          <el-radio :label="1">{{ $t("limitedTime") }}</el-radio>
          <el-radio :label="2">{{ $t("clearance") }}</el-radio>
        </el-radio-group>
      </el-collapse-item>
      <!-- <el-collapse-item
        :title="title2 ? title2 : title1 ? title1 : title ? title : $t('type')"
        name="1"
        class="disabled-collapse"
      > -->
      <!-- <el-checkbox-group v-model="params.category_id" @change="checkChange">
          <el-checkbox
            v-for="item in selectList.categories"
            :label="item.category_id"
            :key="item.category_id"
          >
            {{ item.cn_name }}
          </el-checkbox>
        </el-checkbox-group> -->
      <div class="nowClass">
        {{ oneclassName }}
      </div>
      <div>
        <div
          v-for="(item, index) in classLists"
          @click.prevent="chnageClass(index, item.category_id)"
          :key="item.category_id"
        >
          <div class="flexsbanax">
            <div class="flexsb">
              <!-- currentLeader.svg -->
              <img
                @click.stop="chnageCatenew(item.category_id, item)"
                :src="
                  item.checkBox && item.checkBox == 1
                    ? '/images/newpcImg/currentLeader.svg'
                    : item.checkBox &&
                      item.checkBox == 2 &&
                      category_idList.indexOf(item.category_id) !== -1
                    ? '/images/newpcImg/classBox.svg'
                    : '/images/newpcImg/noClassBox.svg'
                "
                class="Checkbox"
              />
              <div
                :class="
                  category_idList.indexOf(item.category_id) !== -1
                    ? 'classNameslea hoverone'
                    : 'className hoverone'
                "
              >
                {{ item.cn_name }}
              </div>
            </div>
            <img
              src="/images/newpcImg/rightIconsa.png"
              :class="item.isCurrent ? 'righsarotate' : 'rightIconsa'"
              alt=""
            />
          </div>
          <div v-if="item.isCurrent">
            <div
              class="cboxFlex mleft20"
              v-for="(itemsa, index) in item.child"
              @click.stop="chnageCatenew(itemsa.category_id)"
              :key="index"
            >
              <img
                :src="
                  category_idList.indexOf(itemsa.category_id) !== -1
                    ? '/images/newpcImg/classBox.svg'
                    : '/images/newpcImg/noClassBox.svg'
                "
                class="Checkbox"
              />
              <div
                :class="
                  category_idList.indexOf(itemsa.category_id) !== -1
                    ? 'classNametow hovetwo'
                    : 'classNameas hovetwo'
                "
              >
                {{ itemsa.cn_name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </el-collapse-item> -->
      <el-collapse-item
        :title="$t('sort')"
        name="4"
        disabled
        class="disabled-collapse mtop20none"
      >
        <el-select
          class="shop-checked-selectBox"
          v-model="params.sorting"
          @change="$emit('sort-change', params.sorting)"
        >
          <el-option :value="0" :label="$t('sortDefault')"> </el-option>
          <el-option :value="1" :label="$t('SalesHighToLow')"> </el-option>
          <el-option :value="2" :label="$t('PriceHighToLow')"> </el-option>
          <el-option :value="3" :label="$t('PriceLowToHigh')"> </el-option>
          <el-option :value="4" :label="$t('ProductNewToOld')"> </el-option>
        </el-select>
      </el-collapse-item>
      <el-collapse-item
        :title="$t('brand')"
        name="2"
        disabled
        class="disabled-collapse mtop20none"
        v-if="selectList.brand && selectList.brand.length"
      >
        <el-select
          :placeholder="$t('pleaseSelect')"
          default-first-option
          filterable
          multiple
          @change="selectChange"
          v-model="params.brand_id"
        >
          <el-option
            v-for="item in selectList.brand"
            :key="item.brand_id"
            :label="item.cn_name"
            :value="item.brand_id"
          >
          </el-option>
        </el-select>
        <!-- <div class="flexwrap">
          <div class="flexBrand" v-for="item in brandList" :key="item.brand_id">
            <div class="brandName">{{ item.cn_name }}</div>
            <img src="/images/newpcImg/errorIcon.png" class="clearIcon" />
          </div>
        </div> -->
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    selectList: Object,
    isWhale: Boolean,
    routeids: String,
    isOne: {
      type: Boolean,
      default: false,
    },
    title1: String,
    title2: String,
    title: String,
    getListParams: Object,
  },
  data() {
    return {
      activeNames: ["1", "2", "3", "4"],
      brandList: [],
      params: {
        category_id: [],
        brand_id: [],
        sorting: 0,
        sale: 1,
      },
      timer: null,
      category_idList: [],
      classLists: [],
      oneclassName: "",
      isIndex: 0,
      changeClassLists: 0,
    };
  },
  mounted() {
    this.params = this.getListParams;
    this.getcategories();
    // this.category_idList = this.getListParams.category_id;
  },
  watch: {
    changeClassLists: {
      handler(newValue, oldValue) {
        // console.log(
        //   newValue,
        //   "newValuenewValue",
        //   this.category_idList,
        //   this.isIndex
        // );
        this.classLists.forEach((e) => {
          const ids = [];
          e.child.forEach((c) => {
            if (this.category_idList.indexOf(c.category_id) !== -1) {
              ids.push(c.category_id);
            }
          });
          // console.log(ids, "idsidsids", e.twoIds);
          if (e.twoIds.length > 0) {
            if (e.twoIds.length == ids.length) {
              e.checkBox = 2;
              if (this.category_idList.indexOf(e.category_id) == -1) {
                this.category_idList.push(e.category_id);
              }
            } else if (ids.length > 0) {
              e.checkBox = 1;
              if (this.category_idList.indexOf(e.category_id) !== -1) {
                const i = this.category_idList.indexOf(e.category_id);
                this.category_idList.splice(i, 1);
              }
            } else {
              e.checkBox = false;
            }
          }
        });
        console.log(this.category_idList, "thiscategory_idList");
        this.createThrottle((that) => {
          if (that.isOne) {
            that.$emit("check-change", this.category_idList);
          } else {
            that.$parent.$parent.checkChange(this.category_idList);
          }
        });
      },
    },
  },
  methods: {
    // 打开二级分类
    chnageClass(index, category_id) {
      this.classLists[index].isCurrent = !this.classLists[index].isCurrent;
      this.classLists = JSON.parse(JSON.stringify(this.classLists));
    },
    chnageCatenew(id, item) {
      // console.log(item, "itemitemitem", this.category_idList);
      if (item) {
        if (item.twoIds.length <= 0) {
          // 二级分类没有下级选中
          if (this.category_idList.indexOf(id) !== -1) {
            const i = this.category_idList.indexOf(id);
            this.category_idList.splice(i, 1);
          } else {
            this.category_idList.push(id);
          }
        } else {
          // 二级选中
          if (item && item.checkBox == 2) {
            item.child.forEach((e) => {
              const i = this.category_idList.indexOf(e.category_id);
              this.category_idList.splice(i, 1);
            });
            const i = this.category_idList.indexOf(id);
            this.category_idList.splice(i, 1);
          } else if (item && item.checkBox == 1) {
            item.child.forEach((e) => {
              if (this.category_idList.indexOf(e.category_id) == -1) {
                this.category_idList.push(e.category_id);
              }
            });
          } else if (item && !item.checkBox) {
            item.child.forEach((e) => {
              this.category_idList.push(e.category_id);
            });
            this.category_idList.push(id);
          }
        }
      } else {
        console.log(id, "1111111111111");
        // 三级选中
        if (this.category_idList.indexOf(id) !== -1) {
          const i = this.category_idList.indexOf(id);
          this.category_idList.splice(i, 1);
        } else {
          this.category_idList.push(id);
        }
      }

      // console.log(this.category_idList, "1this.category_idList");
      this.changeClassLists = this.changeClassLists + 1;
    },
    chnageCate(items, e, ParentId, parItem) {
      const idList = [];
      const parentlength = parItem.child.length;
      parItem.child.forEach((clId) => {
        if (this.category_idList.indexOf(clId.category_id) != -1) {
          idList.push(clId.category_id);
        }
      });
      if (items.child && items.child.length > 0) {
        if (idList.length == parentlength) {
          const i = this.category_idList.indexOf(e);
          this.category_idList.splice(i, 1);
          items.child.forEach((el) => {
            const i = this.category_idList.indexOf(el.category_id);
            this.category_idList.splice(i, 1);
          });
        } else {
          items.child.forEach((el) => {
            if (this.category_idList.indexOf(el.category_id) == -1) {
              this.category_idList.push(el.category_id);
            }
          });
          this.category_idList.push(e);
        }
      } else {
        if (this.category_idList.indexOf(e) != -1) {
          const i = this.category_idList.indexOf(ParentId);
          console.log(123123, ParentId, i);
          if (this.category_idList.indexOf(ParentId) != -1) {
            this.category_idList.splice(i, 1);
          }
          const is = this.category_idList.indexOf(e);
          this.category_idList.splice(is, 1);
        } else {
          idList.push(e);
          this.category_idList.push(e);
          if (idList.length == parentlength) {
            this.category_idList.push(ParentId);
          }
        }
      }
      this.createThrottle((that) => {
        if (that.isOne) {
          that.$emit("check-change", this.category_idList);
        } else {
          that.$parent.$parent.checkChange(this.category_idList);
        }
      });
    },
    getcategories() {
      this.$json.get("category/api").then((res) => {
        const that = this;
        res.data.forEach((e) => {
          if (e.category_id == this.routeids) {
            that.oneclassName = e.cn_name;
            this.classLists = e.child;
            this.isIndex = 1;
            // this.category_idList.push(e.category_id);
            e.child.forEach((pt) => {
              this.category_idList.push(pt.category_id);
            });
          } else {
            e.child.forEach((c) => {
              if (c.category_id == this.routeids) {
                that.oneclassName = e.cn_name;
                this.classLists = e.child;
                this.category_idList.push(c.category_id);
                this.isIndex = 2;
              } else {
                c.child.forEach((el) => {
                  if (el.category_id == this.routeids) {
                    that.oneclassName = e.cn_name;
                    this.classLists = e.child;
                    this.isIndex = 3;
                    this.category_idList.push(el.category_id);
                  }
                });
              }
            });
          }
        });
        this.classLists.forEach((e) => {
          e.isCurrent = false;
          e.twoIds = [];
          e.child.forEach((c) => {
            if (this.isIndex == 3) {
              if (this.category_idList.indexOf(c.category_id) !== -1) {
                e.checkBox = 1;
                e.isCurrent = true;
              }
            }
            e.twoIds.push(c.category_id);
          });
          if (this.category_idList.indexOf(e.category_id) !== -1) {
            e.checkBox = 2;
            this.category_idList.push(...e.twoIds);
            e.isCurrent = this.isIndex == 1 ? false : true;
          }
        });
      });
    },
    createThrottle(callback) {
      this.timer && clearTimeout(this.timer);
      let that = this;
      this.timer = setTimeout(() => callback(that), 600);
    },
    checkChange(arr) {
      this.createThrottle((that) => {
        if (that.isOne) {
          that.$emit("check-change", arr);
        } else {
          that.$parent.$parent.checkChange(arr);
        }
      });
    },
    selectChange(arr) {
      this.createThrottle((that) => that.$parent.$parent.selectChange(arr));
    },
    radioChange(val) {
      this.createThrottle((that) => that.$parent.$parent.radioChange(val));
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-select .el-input__inner:focus {
  border-color: #999 !important;
}
/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: #999 !important;
}
/deep/ .el-input__inner:focus {
  border-color: #999 !important;
}
/deep/ .el-input__inner {
  height: 1.1538rem !important;
  line-height: 1.1538rem !important;
  border-radius: 0px !important;
  outline-color: #999 !important;
}
.nowClass {
  font-size: 0.5385rem;
  font-weight: bold;
  color: #333;
  padding: 0.3846rem 0;
}
.flexsb {
  display: flex;
  align-items: center;
  height: 1.5385rem;
}
.flexsbanax {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.rightIconsa {
  width: 0.4615rem;
  height: 0.4615rem;
}
.righsarotate {
  width: 0.4615rem;
  height: 0.4615rem;
  transform: rotate(90deg);
}
.hoverone:hover {
  font-size: 0.5385rem;
  font-weight: bold;
  color: #ff7802;
}
.hovetwo:hover {
  font-size: 0.5385rem;
  font-weight: 400;
  color: #ff7802;
}
/deep/ .el-select .el-tag {
  background-color: #fff0e5 !important;
  .el-select__tags-text {
    font-size: 0.4615rem;
    font-weight: 500;
    color: #ff7802;
  }
}
/deep/ .el-select .el-tag__close.el-icon-close {
  background-color: #ff7802;
}
.brandName {
  font-size: 0.4615rem;
  font-weight: 500;
  color: #ff7802;
}
.clearIcon {
  width: 0.3846rem;
  height: 0.3846rem;
  margin-left: 0.3846rem;
}
.flexwrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.flexBrand {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background: #fff0e5;
  padding: 0.0769rem 0.2308rem;
  margin-top: 0.3846rem;
  margin-right: 0.3846rem;
}
.mleft20 {
  margin-left: 1.1538rem;
  overflow: hidden;
}
.cboxFlex {
  display: flex;
  align-items: center;
  height: 1.5385rem;
}
.Checkbox {
  width: 0.7692rem;
  height: 0.7692rem;
}
.classNametow {
  cursor: pointer;
  margin-left: 0.3846rem;
  font-size: 0.5385rem;
  font-weight: 500;
  color: #333;
}
.classNameslea {
  cursor: pointer;
  margin-left: 0.3846rem;
  font-size: 0.5385rem;
  font-weight: bold;
  color: #333;
}
.className {
  cursor: pointer;
  margin-left: 0.3846rem;
  font-size: 0.5385rem;
  font-weight: bold;
  color: #666;
}
.classNameas {
  cursor: pointer;
  margin-left: 0.3846rem;
  font-size: 0.5385rem;
  font-weight: 400;
  color: #666;
}
.disabled-collapse /deep/ .el-icon-arrow-right {
  font-size: 0.6154rem;
  font-weight: bold;
}
.disabled-collapse /deep/ .el-icon-arrow-up:before {
  font-weight: bold;
  color: #333;
  font-size: 0.6154rem;
}
.mtop20none /deep/ .el-icon-arrow-right {
  display: none;
  margin-top: 0.7692rem;
}
.mtop20none {
  margin-top: 0.7692rem;
}
.disabled-collapse /deep/ div .el-collapse-item__header {
  color: #303133;
  cursor: auto;
  .el-collapse-item__arrow {
    font-size: 0.5385rem;
    font-weight: bold;
  }
}
.screen {
  width: 9.0385rem;
  min-height: 10.3846rem;
  padding: 0.3846rem 0.7692rem 0.7692rem 0.7692rem;
  background-color: #fff;
  position: sticky;
  top: 0.3846rem;
  box-sizing: border-box;
  .el-radio-group {
    display: flex;
    flex-direction: column;
  }
  /deep/ .el-collapse {
    padding: 0;
    border: none;
    .el-collapse-item__header {
      height: 1.5385rem;
      // background: #f9f9f9;
      font-size: 0.5385rem;
      font-weight: bold;
      // height: 1.9231rem;
    }
    .el-collapse-item__wrap {
      // background: #f9f9f9;
      border: none;
      .el-collapse-item__content {
        padding-bottom: 0;
        display: flex;
        flex-direction: column;
        .el-select .el-input {
          .el-input__inner {
            height: 1.5385rem;
            font-size: 0.5385rem;
          }
        }
        .el-radio {
          padding: 0.3077rem 0;
          .el-radio__label {
            color: #333;
            font-size: 0.5385rem;
          }
        }
      }
      .el-checkbox-group {
        display: flex;
        flex-direction: column;
        margin-top: 0.1923rem;
        & > .el-checkbox {
          line-height: 1.1538rem;
          .el-checkbox__label {
            font-size: 0.6923rem;
            color: #333;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/sidebar2.vue